<template>
  <div>
    <kst-output print-mode field="PayNumber" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="Date" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="WarehouseID" :data="data" :catalog="Catalog"/>
    <template v-if="isStatusVoid">
      <kst-output print-mode field="StatusID" :data="data" :catalog="Catalog"/>
      <kst-output print-mode field="VoidByID" :data="data" :catalog="Catalog"/>
      <kst-output print-mode field="VoidDate" :data="data" :catalog="Catalog"/>
      <kst-output print-mode field="VoidComment" :data="data" :catalog="Catalog"/>
    </template>
  </div>
</template>

<script>
import Catalog from "../RcpyCatalog.js";
import Model from "../RcpyModel.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  }),
  computed: {
    isStatusVoid() {
      return this.data.StatusID === Model.StatusID.Void.ID;
    }
  }
}
</script>